import { z } from 'zod';
import { errorMap } from 'zod-validation-error';

import { deepCopy, getErrorKeys, removeKeysFromObject } from '../optionsSchemaUtils';
import { PaymentElementOptions } from './PaymentElement';

const FieldSchema = z
  .object({ hidden: z.boolean().optional(), readOnly: z.boolean().optional() })
  .optional();
const EventConfig = z.object({ key: z.string().min(1), fn: z.function() });
const DISPLAY_MODES = ['full-screen', 'container'] as const;

export const PaymentElementOptionsSchema = z.object({
  sessionId: z.string().trim().min(1),
  displayMode: z.enum(DISPLAY_MODES).optional(),
  fields: z
    .object({
      first_name: FieldSchema,
      last_name: FieldSchema,
      email: FieldSchema,
      city: FieldSchema,
      country: FieldSchema,
      state: FieldSchema,
      address: FieldSchema,
      zip: FieldSchema,
      phone: FieldSchema,
      business_name: FieldSchema
    })
    .strict()
    .optional(),
  events: z.array(EventConfig).optional(),
  showDocumentCollector: z.boolean().optional(),
  showAmountPanel: z.boolean().optional()
});

export const parsePaymentElementOptions = (options: PaymentElementOptions) => {
  const mandatoryResult = PaymentElementOptionsSchema.safeParse(options, { errorMap });
  const initialOptions = deepCopy(options);

  if (!mandatoryResult.success && mandatoryResult.error.flatten().fieldErrors['sessionId']) {
    return { errors: mandatoryResult.error.errors };
  }

  const errorKeys = getErrorKeys(mandatoryResult.error?.errors || []);
  const sanitizedOptions = removeKeysFromObject(options, errorKeys);

  return !mandatoryResult.success
    ? {
        warnings: mandatoryResult.error.flatten().fieldErrors,
        options: sanitizedOptions as PaymentElementOptions,
        initialOptions
      }
    : {
        options: mandatoryResult.data as PaymentElementOptions,
        initialOptions
      };
};
